
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import AuthForm from '@/components/auth/AuthForm';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHeader from '@/components/PageHeader';

const Auth = () => {
  const { isAuthenticated, loading, makeOrganizer } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="min-h-screen flex flex-col bg-gradient-to-b from-black to-indigo-950">
        <Header />
        <PageHeader 
          title=""
          subtitle=""
          backgroundImage="/lovable-uploads/75e6360c-a56e-48e7-9e3c-5903e26ee0a6.png"
        />
        <div className="flex-grow flex items-center justify-center pt-28 pb-20">
          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-lg border border-purple-500/20 w-full max-w-md">
            <h1 className="text-2xl font-bold text-white mb-6 text-center">You're Already Signed In</h1>
            <p className="text-gray-300 mb-8 text-center">
              You are already authenticated and can access all features of the AI Summit platform.
            </p>
            
            <div className="space-y-4">
              <Button 
                onClick={makeOrganizer}
                className="w-full bg-purple-600 hover:bg-purple-700 text-white"
              >
                Become an Organizer (Testing)
              </Button>
              <Button 
                variant="outline" 
                className="w-full border-purple-500/30 text-purple-300"
                onClick={() => window.location.href = '/'}
              >
                Return to Home
              </Button>
            </div>
            
            <p className="text-xs text-gray-400 mt-6 text-center">
              The "Become an Organizer" button is for testing purposes only. 
              It allows you to access the admin dashboard to manage speakers and schedule.
            </p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-black to-indigo-950">
      <Header />
      <PageHeader 
        title=""
        subtitle=""
        backgroundImage="/lovable-uploads/75e6360c-a56e-48e7-9e3c-5903e26ee0a6.png"
      />
      <div className="flex-grow flex items-center justify-center pt-28 pb-20">
        <AuthForm view="sign_in" setView={() => {}} />
      </div>
      <Footer />
    </div>
  );
};

export default Auth;
